import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import cond from 'lodash/cond';

import { SuiContainer, SuiLabel } from '@splashthat/sui';
import { containerPaddingXs } from 'common/styles/variables';

import { getFormNode } from 'common/entities/formNode/selectors';
import disableWhenLocked from './disableWhenLocked';
import { isTemporaryId } from '../../../utils/formValidations';

const TAG_LABEL = 'Personalization Tag';

const FullWidthContainer = styled.div`
    width: 100%;
`;

const PaddedRightLabelWrapper = styled.div`
    padding-right: ${containerPaddingXs};
`;

const PersonalizationTagControl = (props) => {
    const { formNodeId, personalizationTag } = props;
    const isTemp = isTemporaryId(formNodeId);
    const displayText = cond([
        [() => isTemp, () => 'Generated after save'],
        [() => personalizationTag, () => `[${personalizationTag}]`],
        // The BE doesn't populate personalizationTag in the Form Library because it doesn't have Event context.
        [() => !personalizationTag, () => 'Not generated for the Form Library'],
    ])();

    return (
        <FullWidthContainer>
            <SuiContainer variation="flex-horizontal-left">
                <PaddedRightLabelWrapper>
                    <SuiLabel text={TAG_LABEL} />
                </PaddedRightLabelWrapper>
            </SuiContainer>
            <FullWidthContainer>
                <SuiLabel text={displayText} secondary />
            </FullWidthContainer>
        </FullWidthContainer>
    );
};

PersonalizationTagControl.propTypes = {
    formNodeId: PropTypes.string,
    personalizationTag: PropTypes.string,
};

PersonalizationTagControl.defaultProps = {
    formNodeId: undefined,
    personalizationTag: null,
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formNode = getFormNode(state, props.formNodeId);
    return {
        formNodeId: props.formNodeId,
        personalizationTag: props.formNodeId ? formNode.personalizationTag : null,
    };
};

const ConnectedPersonalizationTagControl = connect(mapStateToProps)(disableWhenLocked(PersonalizationTagControl));

ConnectedPersonalizationTagControl.propTypes = {
    formNodeId: PropTypes.string,
};

ConnectedPersonalizationTagControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedPersonalizationTagControl;
